var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    {
      attrs: { show: _vm.show },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _c(
        "CabeceraModalCrear",
        {
          attrs: { titulo: "Cambio de Servicio" },
          on: { cerrar: _vm.closeModal }
        },
        [
          _vm.accion_modal == "CREAR"
            ? _c(
                "div",
                { staticClass: "boton_crear" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "icon",
                      staticStyle: {
                        "background-color": "rgb(255, 108, 0) !important",
                        "border-color": "rgb(255, 108, 0) !important",
                        "padding-right": "20px !important",
                        display: "block",
                        margin: "0 0 0 auto",
                        "margin-top": "13px",
                        height: "38px"
                      },
                      attrs: { color: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.probar()
                        }
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "color-blanco",
                          staticStyle: { color: "white" }
                        },
                        [_vm._v("Guardar")]
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _c(
        "v-card",
        { attrs: { height: "55px", flat: "" } },
        [
          _c(
            "v-bottom-nav",
            {
              attrs: {
                value: true,
                active: _vm.pasos.informacionGeneral.step,
                absolute: "",
                color: "transparent"
              },
              on: {
                "update:active": function($event) {
                  return _vm.$set(_vm.pasos.informacionGeneral, "step", $event)
                }
              }
            },
            [
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pasos.informacionGeneral.visible,
                      expression: "pasos.informacionGeneral.visible"
                    }
                  ],
                  attrs: {
                    color: "primary",
                    flat: "",
                    value: _vm.pasos.informacionGeneral.step
                  },
                  on: { click: _vm.handleInfoGeneral }
                },
                [
                  _c("span", [_vm._v("Detalle")]),
                  _c("v-icon", [_vm._v("info")])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showInfo,
              expression: "showInfo"
            }
          ],
          staticClass: "cardnew",
          attrs: { align: "center" }
        },
        [
          _c("br"),
          _c(
            "div",
            { staticClass: "orden_compra", attrs: { align: "center" } },
            [
              _c(
                "v-flex",
                { attrs: { md10: "" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "rounded-card" },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          staticClass: "col-md-12",
                          attrs: { "lazy-validation": "" }
                        },
                        [
                          _c(
                            "v-container",
                            { attrs: { "grid-list-md": "" } },
                            [
                              _vm.accion_modal == "EDITAR"
                                ? _c("h1", [
                                    _vm._v(
                                      "\n                Detalle: " +
                                        _vm._s(_vm.id_cs) +
                                        " (Estado : " +
                                        _vm._s(_vm.estado) +
                                        ")\n              "
                                    )
                                  ])
                                : _vm._e(),
                              _vm.accion_modal == "CREAR"
                                ? _c("h1", [_vm._v("Nuevo Cambios de SerTec")])
                                : _vm._e(),
                              _c("CabezeraCS", {
                                ref: "CabezeraCSRef",
                                attrs: {
                                  accion_modal: _vm.accion_modal,
                                  id_cs: _vm.id_cs
                                },
                                on: {
                                  enviarTecnico: function($event) {
                                    return _vm.recibirTecnico($event)
                                  },
                                  activar_modo: function($event) {
                                    return _vm.activar_modo($event)
                                  }
                                }
                              }),
                              _c("EquipoCliente", {
                                ref: "EquipoClienteCSRef",
                                attrs: {
                                  accion_modal: _vm.accion_modal,
                                  serienumero: _vm.serienumero,
                                  tipoeqid: _vm.tipoeqid,
                                  tecnico_id: _vm.tecnico_id,
                                  titulo: _vm.titulo,
                                  estado: _vm.estado
                                },
                                on: {
                                  enviarEquipo: function($event) {
                                    return _vm.recibirRecibirEquipo($event)
                                  },
                                  enviarNumero: function($event) {
                                    return _vm.recibirRecibirNumero($event)
                                  }
                                }
                              }),
                              _vm.accion_modal == "CREAR"
                                ? _c("opcionesCS", {
                                    ref: "opcionesCSRef",
                                    staticClass: "justify-center",
                                    on: { input: _vm.handleInputFromOpcionesCS }
                                  })
                                : _vm._e(),
                              _vm.accion_de_cambio == "RetiroEquipo"
                                ? _c("retiroEquipo", {
                                    attrs: {
                                      envio_numero: _vm.envio_numero,
                                      envio_Equipo: _vm.envio_Equipo,
                                      numero_de_servicio:
                                        _vm.numero_de_servicio,
                                      accion_modal: _vm.accion_modal
                                    }
                                  })
                                : _vm.accion_de_cambio == "reemplazaEquipo"
                                ? _c("reemplazaEquipo", {
                                    ref: "reemplazaEquipoCSRef",
                                    attrs: {
                                      envio_tecnico: _vm.envio_tecnico,
                                      accion_modal: _vm.accion_modal,
                                      titulo: _vm.titulo_reemplazo,
                                      serienumero: _vm.serienumero_entrante,
                                      tipoeqid: _vm.tipoeqid_entrante
                                    }
                                  })
                                : _vm.accion_de_cambio == "CambioSIM"
                                ? _c("CambioSIM", {
                                    ref: "CambioSIMCSRef",
                                    attrs: {
                                      envio_tecnico: _vm.envio_tecnico,
                                      accion_modal: _vm.accion_modal,
                                      titulo: _vm.titulo_cambio_sim_old,
                                      simserienumero_od: _vm.simserienumero_od
                                    }
                                  })
                                : _vm._e(),
                              _vm.nueva_sim
                                ? _c("NuevoCambioSIM", {
                                    ref: "CambioSIMCSRef",
                                    attrs: {
                                      envio_tecnico: _vm.envio_tecnico,
                                      accion_modal: _vm.accion_modal,
                                      titulo: _vm.titulo_cambio_sim_new,
                                      simserienumero_new: _vm.simserienumero_new
                                    }
                                  })
                                : _vm.accion_de_cambio == "CambioActivoCliente"
                                ? _c("CambioActivoCliente", {
                                    ref: "CambioActivoClienteCSRef",
                                    attrs: {
                                      accion_modal: _vm.accion_modal,
                                      cliente_id_saliente:
                                        _vm.cliente_id_saliente,
                                      flota_saliente: _vm.flota_saliente,
                                      patente_saliente: _vm.patente_saliente,
                                      cliente_id_entrante:
                                        _vm.cliente_id_entrante,
                                      flota_entrante: _vm.flota_entrante,
                                      patente_entrante: _vm.patente_entrante,
                                      titulo: _vm.titulo_cambio_activo
                                    }
                                  })
                                : _vm._e(),
                              _vm.nuevo_activo
                                ? _c("NuevoCambioActivoCliente", {
                                    ref: "CambioActivoClienteCSRef",
                                    attrs: {
                                      accion_modal: _vm.accion_modal,
                                      cliente_id_entrante:
                                        _vm.cliente_id_entrante,
                                      flota_entrante: _vm.flota_entrante,
                                      patente_entrante: _vm.patente_entrante,
                                      titulo: _vm.titulo_nuevo_activo
                                    }
                                  })
                                : _vm._e(),
                              _c(
                                "v-flex",
                                { attrs: { sm12: "", md12: "" } },
                                [_c("v-divider")],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }